import React, {Component, createRef} from 'react';
import {GeoJSON, Map, Marker, Polygon, Polyline, Popup, TileLayer} from 'react-leaflet'
import FullscreenControl from 'react-leaflet-fullscreen';
import Control from 'react-leaflet-control';
import 'react-leaflet-fullscreen/dist/styles.css';

class OpenStreetMapChoropleth extends Component {

    constructor(props) {
        super(props);
        this.defaultControllerInfoBox = {title: "Info", description: "Markera polygon för att få mer information\n"}
        this.state = {controllerInfoBox: this.defaultControllerInfoBox}
        this.choroplethRef = createRef();
        this.mapRef = createRef();
        this.updateMapBound = this.updateMapBound.bind(this);
        this.getGeoJsonStyle = this.getGeoJsonStyle.bind(this);

    };

    updateMapBound = () => {
        //const bounds = this.mapRef.current.getBounds();
        const bounds = this.mapRef.current.leafletElement.getBounds();
        const southWest = bounds.getSouthWest();
        const northEast = bounds.getNorthEast();

        // Handle the bounds as needed
        this.props.onMapMoveBounds(southWest, northEast);
    }

    getGeoJsonStyle(feature){
        //console.log(feature.properties.field_value)
        let field_value = feature.properties.field_value;
        return {
            fillColor: this.props.getPolygonColor(field_value),
            weight: 2,
            opacity: 0.2,
            color: 'white',
            dashArray: '3',
            fillOpacity: 0.6
        };
    }

    render() {

        function formatValue(value, unit) {
            // Convert number to string
            let str_value = value.toString();
            str_value = str_value.replace(/\.0+$/, '');
            str_value = str_value.replace(/(\.\d*[1-9])0+$/, '$1');
            // Remove trailing zeros after a decimal point


            if(unit !== "years") {
                str_value = parseFloat(str_value).toLocaleString('en-US', {
                    thousandSeparator: ' ',
                    maximumFractionDigits: 20  // to ensure it doesn't round off
                }).replace(/,/g, ' ');
            }

            switch (unit) {
                case "sqm":
                    unit = "m²";
                    break;
                case "n":
                    unit = "";
                    break;
                default:
                    // You can handle any other cases here or do nothing
                    break;
            }

            return str_value + " " + unit
        }

        function highlightFeature(e){
            var layer = e.target;
            //console.log(layer.feature.properties);
            let field_value_pretty = formatValue(layer.feature.properties.field_value, layer.feature.properties.field_unit);
            this.setState({controllerInfoBox:{
                    title: layer.feature.properties.area_display_name,
                    description: layer.feature.properties.field_display_name,
                    value: field_value_pretty
                }
            });

            layer.setStyle({
                weight: 5,
                dashArray: '',
                fillOpacity: 0.85
            });
            layer.bringToFront();
        }
        function handleMouseOut(e) {
            var layer = e.target;
            layer.setStyle({
                weight: 2,
                dashArray: '3',
                fillOpacity: 0.6
            });
        }


        function zoomToFeature(e) {
            //map.fitBounds(e.target.getBounds());
        }



        return (
            <Map  style={{height: "45vw"}}
                  center={[this.props.mapPositionLat, this.props.mapPositionLng]}
                  zoom={this.props.mapZoomLevel}
                  onmoveend={this.updateMapBound}
                  minZoom={this.props.mapMinZoom}
                  maxZoom={17}
                  whenReady={this.updateMapBound}
                  ref={this.mapRef}>
                <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {/* MARKERS */}
                {this.props.markers.map((row) =>
                    <Marker position={[row[this.props.latName], row[this.props.lonName]]}>
                        <Popup>
                            <h4>{row[this.props.markerTitle]}</h4>
                            <table>
                                {this.props.markerPopupColumns.map(function(column, i){
                                    if (column['name'] !== this.props.markerTitle && row[column['name']]){
                                        return <tr><td><b>{column['prettyName']}</b></td><td>{row[column['name']]}</td></tr>
                                    }
                                },this)}
                            </table>

                            <a type="button"  class="btn btn-info btn-lg btn-block" href={'#row' + row['id']}>More information</a>
                        </Popup>
                    </Marker>
                )}

                {/* POLYLINE */}
                {this.props.polylines.map((row) =>
                    <Polyline  color="red" positions={row}>
                        <Popup>
                            <h4>test</h4>
                        </Popup>
                    </Polyline>
                )}

                {/* POLYGON */}
                {this.props.polygons.map((row) =>
                    <Polygon color="lime" positions={row}>
                        <Popup>
                            <h4>test</h4>
                        </Popup>
                    </Polygon>
                )}

                {/* CHOROPLETH */}
                {this.props.geojson && <GeoJSON
                    key={JSON.stringify(this.props.geojson)}
                    data={this.props.geojson}
                    //style={getStyle.bind(this)}
                    onEachFeature={(feature, layer) =>{
                        //console.log(feature)
                        layer.setStyle(this.getGeoJsonStyle(feature))
                        layer.on({
                        mouseover: highlightFeature,
                        mouseout: handleMouseOut,
                        click: zoomToFeature
                    }, this)}} //     //  this.refs.geoJsonRef.geojson.leafletElement.resetStyle(e.target);
                    ref={this.choroplethRef}
                />}

                <Control position="topleft" >
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">{this.state.controllerInfoBox.title}</h5>
                            {/*<h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>*/}
                            <p class="card-text"><i>{this.state.controllerInfoBox.description}</i></p>
                            <p className="card-text"><b>{this.state.controllerInfoBox.value}</b></p>
                            {/*<a href="#" class="card-link">Card link</a>*/}
                            {/*<a href="#" class="card-link">Another link</a>*/}
                        </div>
                    </div>
                </Control>

                <FullscreenControl position="topright" />
            </Map>
        )
    }
}

export default OpenStreetMapChoropleth;
